import { render } from "./BranchAttendance.vue?vue&type=template&id=56d4c1fc&scoped=true"
import script from "./BranchAttendance.vue?vue&type=script&lang=js"
export * from "./BranchAttendance.vue?vue&type=script&lang=js"

import "./BranchAttendance.vue?vue&type=style&index=0&id=56d4c1fc&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d4c1fc"]])

export default __exports__